webpackJsonp([1],{

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(996)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(1120),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2a6dc774",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(1129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(1126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(1116),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(1138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(1140),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(1118),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(1122),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(1119),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(1132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(1133),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(1130),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1101:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(1141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1102:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(1135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1103:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(1131),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1104:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(1128),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(1127),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1106:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(1125),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(1124),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(1139),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(1134),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(1137),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(1117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(1114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(1136),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1114:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.slideClass
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1115:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [(_vm.feedbackUrl) ? _c('div', {
    attrs: {
      "id": "feedback"
    }
  }, [_c('button', {
    on: {
      "click": _vm.openFeedback
    }
  }, [_c('i', {
    staticClass: "fas fa-comment"
  }), _vm._v(" Feedback")])]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1116:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "course-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "course-name req-name"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "\n    ")]), _vm._v(" "), (_vm.req.advanced) ? _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours: " + _vm._s(_vm.req.credits))]) : _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours: " + _vm._s(_vm.req.course.minimum_credits))]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Minimum Grade: " + _vm._s(_vm.req.minimum_grade))]), _vm._v(" "), (_vm.req.advanced) ? _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Attempts: " + _vm._s(_vm.req.attempts))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.req.course.description) ? _c('div', {
    staticClass: "course-description"
  }, [_vm._v("\n      Course Description: " + _vm._s(_vm.req.course.description) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.req.course.prereq) ? _c('div', {
    staticClass: "course-prereq"
  }, [_vm._v("\n      Prerequisites:\n      "), _c('requisites-string', {
    attrs: {
      "operand": _vm.req.course.prereq,
      "requisiteType": "prereq"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.req.course.coreq) ? _c('div', {
    staticClass: "course-coreq"
  }, [_vm._v("\n      Corequisites:\n      "), _c('requisites-string', {
    attrs: {
      "operand": _vm.req.course.coreq,
      "requisiteType": "coreq"
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),

/***/ 1117:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.loaded) ? _c('div', {
    attrs: {
      "id": "university"
    }
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "property": "stylesheet",
      "href": _vm.stylesheet
    }
  }), _vm._v(" "), (!_vm.$store.getters.isUnmMain) ? _c('header', {
    staticClass: "ds-main",
    class: {
      'ds-background': !_vm.homeRoute,
      'home': _vm.homeRoute
    }
  }, [_c('div', {
    attrs: {
      "id": "header-wraper"
    }
  }, [_c('router-link', {
    staticClass: "header-img",
    attrs: {
      "to": {
        name: 'landing'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu-items"
    }
  }, [_c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      focused: _vm.searchFocused
    },
    attrs: {
      "id": "search-menu"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search or jump to..."
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocused = true
      },
      "blur": function($event) {
        _vm.searchFocused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.searchFocused) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, [(_vm.$route.name !== 'nameSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("All Programs")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'interestSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("Interest Areas")])], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (_vm.showProgramLevelMenu) ? _c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      selected: _vm.showProgramLevelDropdown
    },
    attrs: {
      "id": "program-level-menu"
    }
  }, [_c('div', {
    staticClass: "menu-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.showProgramLevelDropdown = !_vm.showProgramLevelDropdown
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectedProgramLevel) + " "), _c('i', {
    staticClass: "fas fa-chevron-down"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.showProgramLevelDropdown) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, _vm._l((_vm.programLevels), function(level) {
    return _c('li', {
      key: level
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectedProgramLevel = level
        }
      }
    }, [_vm._v(_vm._s(level))])])
  }), 0) : _vm._e()])], 1) : _vm._e()])], 1)]) : _c('div', {
    staticClass: "unm-header"
  }, [_c('div', {
    staticClass: "navbar navbar-unm"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'landing'
      }
    }
  }, [_vm._v("\n          The University of New Mexico\n        ")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "department logo block",
      "id": "header",
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      focused: _vm.searchFocused
    },
    attrs: {
      "id": "search-menu"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search Degrees"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocused = true
      },
      "blur": function($event) {
        _vm.searchFocused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.searchFocused) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, [(_vm.$route.name !== 'nameSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("All Programs")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'interestSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("Interest Areas")])], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "unm-footer"
  }, [_c('unm-footer')], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav navbar-nav navbar-right hidden-xs",
    attrs: {
      "id": "toolbar-nav"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu/departments/",
      "title": "UNM A to Z"
    }
  }, [_vm._v("UNM A-Z")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://my.unm.edu",
      "title": "myUNM"
    }
  }, [_vm._v("myUNM")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu",
      "title": "Directory"
    }
  }, [_vm._v("Directory")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "aria-label": "Secondary Navigation",
      "id": "top-nav"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right",
    attrs: {
      "role": "menubar"
    }
  }, [_c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://students.unm.edu/navigating-your-major/index.html"
    }
  }, [_vm._v("Advisement")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://studenthub.unm.edu"
    }
  }, [_vm._v("Student Hub")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://catalog.unm.edu"
    }
  }, [_vm._v("Catalog")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://schedule.unm.edu"
    }
  }, [_vm._v("Course Schedules")])])])])
}]}

/***/ }),

/***/ 1118:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasPlans) ? _c('div', {
    staticClass: "program"
  }, [_c('i', {
    staticClass: "program-bookmark fa fa-bookmark"
  }), _vm._v(" "), _c('div', {
    class: {
      "program-line": _vm.concentrations.length > 0
    }
  }), _vm._v(" "), _vm._l((_vm.programsToShow), function(program) {
    return _c('unit', {
      key: program.university_layout_id,
      attrs: {
        "unit": program
      }
    })
  }), _vm._v(" "), _vm._l((_vm.concentrations), function(concentration) {
    return _c('unit', {
      key: concentration.id,
      staticClass: "concentration",
      attrs: {
        "unit": concentration
      }
    })
  })], 2) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1119:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showArchived) ? _c('unit-archived', {
    attrs: {
      "unit": _vm.unit
    }
  }) : _c('unit-current', {
    attrs: {
      "unit": _vm.unit
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "career-opportunities"
    }
  }, [_c('h2', [_vm._v("Career Opportunities")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.cip.definition))]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.occupations.length) ? [_c('table', [_vm._m(1), _vm._v(" "), _c('tr', {
    staticClass: "salary-row"
  }, [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "salary-cell"
  }, [_c('div', {
    staticClass: "salary-scale"
  }, [_c('div', {
    staticClass: "salary-scale-min salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMin)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-mid salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMid)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-max salary-scale-label"
  }, [_vm._v(_vm._s(_vm.dollars(_vm.salaryMax)))]), _vm._v(" "), _c('div', {
    staticClass: "salary-scale-domain"
  })])])]), _vm._v(" "), _vm._l((_vm.occupations), function(occupation) {
    return (occupation.salary && occupation.tags && occupation.salary.annual_median) ? _c("occupation", {
      key: occupation.code,
      tag: "tr",
      attrs: {
        "occupation": occupation,
        "salary-min": _vm.salaryMin,
        "salary-range": _vm.salaryRange
      }
    }) : _vm._e()
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "note-everyday"
  }, [_vm._v("\n      Career data obtained from the Occupational Information Network (O*NET).\n      These occupations are identified based on the CIP code for " + _vm._s(_vm.cip.name) + "\n      (" + _vm._s(_vm.cip.code) + "). The salary range depicts the 10th percentile, median, and\n      90th percentile salary values for each occupation.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "job-legend"
  }, [(_vm.showGreenLegend) ? [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("\n          Green occupations will likely change as a result of the green economy.\n          Green economy activities and technologies are increasing the demand for\n          occupations, shaping the work and worker requirements needed for\n          occupational performance, or generating new and emerging occupations.\n        ")])] : _vm._e(), _vm._v(" "), (_vm.showBrightOutlookLegend) ? [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("\n          Bright Outlook occupations are expected to grow rapidly in the next\n          several years, will have large numbers of job openings, or are new and\n          emerging occupations.\n        ")])] : _vm._e()], 2)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "disclosure"
  }, [_c('i', {
    staticClass: "fa-solid fa-exclamation-circle"
  }), _vm._v(" "), _c('i', [_vm._v("Some occupations associated with this program may require professional licensure for employment. While this program's curriculum may include coursework relevant to licensure, licensure requirements vary by state and profession. To determine whether a specific academic program meets educational requirements for licensure in your state, refer to the UNM Professional Licensure Disclosure Page.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Occupation")]), _vm._v(" "), _c('th', [_vm._v("Median Salary")]), _vm._v(" "), _c('th', {
    staticClass: "salary-cell"
  }, [_vm._v("Salary Range")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-legend-header"
  }, [_c('span', {
    staticClass: "job-legend-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(397),
      "height": "24"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "job-legend-label"
  }, [_vm._v("Green Occupation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "job-legend-header"
  }, [_c('span', {
    staticClass: "job-legend-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(396),
      "height": "24"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "job-legend-label"
  }, [_vm._v("Bright Outlook")])])
}]}

/***/ }),

/***/ 1121:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.req.type == 'CoreRequirement') ? _c('div', {
    staticClass: "coreinfo"
  }, [_c('requirement', {
    ref: "coreRequirement",
    attrs: {
      "req": _vm.req.core
    }
  })], 1) : _c('div', {
    staticClass: "requirement"
  }, [(_vm.req.type == 'DegreeRequirement') ? _c('degree-requirement', {
    ref: "degreeRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e(), _vm._v(" "), (_vm.req.type == 'CourseRequirement') ? _c('course', {
    ref: "courseRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e(), _vm._v(" "), (_vm.req.type == 'WildCardRequirement') ? _c('wildcard', {
    ref: "wildCardRequirement",
    attrs: {
      "req": _vm.req
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1122:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    staticClass: "program-info-wrap"
  }, [_c('h2', [_vm._v(" " + _vm._s(_vm.informationType) + " Information ")]), _vm._v(" "), _c('p', {
    staticClass: "program-info"
  }, [_c('code', {
    staticClass: "program-info",
    domProps: {
      "innerHTML": _vm._s(_vm.programInfo)
    }
  })]), _vm._v(" "), (_vm.onlineAvailability) ? _c('p', [_c('b', [_vm._v("Online Availability:")]), _vm._v(" " + _vm._s(_vm.onlineAvailability))]) : _vm._e(), _vm._v(" "), _c('hr')]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1123:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "majors-list"
  }, [_c('div', {
    staticClass: "majors-toggle-archived banner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "academic-period-display"
  }, [_c('div', {
    staticClass: "period-label"
  }, [_vm._v("Academic Year")]), _vm._v(" "), (!_vm.showArchived) ? _c('h2', [_vm._v(_vm._s(_vm.currentPeriod.academic_year))]) : _vm._e(), _vm._v(" "), (_vm.showArchived) ? _c('h2', [_vm._v("All Academic Years")]) : _vm._e()]), _vm._v(" "), _c('span', [_c('button', {
    staticClass: "hollow",
    on: {
      "click": _vm.toggleArchived
    }
  }, [_vm._v("\n          " + _vm._s(_vm.showArchived ? "Hide Previous Years" : "Show Previous Years") + "\n        ")])])]), _vm._v(" "), (!_vm.showArchived) ? _c('p', {
    staticClass: "info"
  }, [_vm._v("Listing degrees for the current academic year (" + _vm._s(_vm.currentPeriod.academic_year) + "). If you do not see the plan you are looking for, you may toggle archived years using the button to the right.")]) : _vm._e(), _vm._v(" "), (_vm.showArchived) ? _c('p', {
    staticClass: "info"
  }, [_vm._v("Listing degrees for the all academic years. Use the dropdowns to view a a plan for a specific year.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    ref: "headerPlaceholder",
    staticClass: "listing-header-placeholder",
    class: {
      "header-fixed": _vm.headerFixed
    }
  }), _vm._v(" "), (!_vm.showArchived) ? _c('div', {
    ref: "header",
    staticClass: "listing-header",
    class: {
      "header-fixed": _vm.headerFixed,
      "is-unm": _vm.$store.getters.isUnmMain
    }
  }, [_vm._m(0)]) : _c('div', {
    ref: "header",
    staticClass: "listing-header",
    class: {
      "header-fixed": _vm.headerFixed,
      "is-unm": _vm.$store.getters.isUnmMain
    }
  }, [_vm._m(1)]), _vm._v(" "), _vm._l((_vm.nestedMajors), function(college) {
    return _c('college', {
      key: college.key,
      attrs: {
        "college": college
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "unit-name"
  }, [_c('span', [_vm._v("Level")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-level"
  }, [_c('span', [_vm._v("Degree")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-availabitlity"
  }, [_c('span', [_vm._v("Online")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-plans"
  }, [_c('span', [_vm._v("Plan")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-credits"
  }, [_c('span', [_vm._v("Credits")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Information")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Degree Plan")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "unit-name"
  }, [_c('span', [_vm._v("Level")])]), _vm._v(" "), _c('div', {
    staticClass: "unit-level"
  }, [_c('span', [_vm._v("Degree")])]), _vm._v(" "), _c('div', {
    staticClass: "header-button"
  }, [_c('span', [_vm._v("Academic Period")])])])])
}]}

/***/ }),

/***/ 1124:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "unit"
    }
  }, [_c('div', {
    attrs: {
      "id": "unit-header"
    }
  }, [_c('div', {
    attrs: {
      "id": "unit-name"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.currentPeriod ? _vm.currentPeriod.academic_year : 'NA') + " Academic Year")]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.name)), (_vm.level) ? [_vm._v(", " + _vm._s(_vm.level))] : _vm._e()], 2), _vm._v(" "), (_vm.college) ? _c('h4', [_vm._v(_vm._s(_vm.college))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "header-credits"
  }, [(_vm.unitPeriod && _vm.credits && _vm.$route.name === 'unit-plans') ? _c('span', [_vm._v(_vm._s(_vm.credits) + " Credit Hours")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "breadcrumbs"
  }, [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack.apply(null, arguments)
      }
    }
  }, [_vm._v("Majors")]), _vm._v(" / "), _c('span', [_vm._v(_vm._s(_vm.programName))]), _vm._v(" "), (_vm.concentrationName) ? _c('span', [_vm._v(_vm._s(_vm.concentrationName))]) : _vm._e(), _vm._v(" "), (_vm.$route.name === "unit-plans") ? [_vm._v("/ "), _c('span', [_vm._v("Degree Plan")])] : _vm._e()], 2)]), _vm._v(" "), _c('router-view')], 1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-container"
  }, [_c('div', {
    staticClass: "background-image"
  })])
}]}

/***/ }),

/***/ 1125:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-content"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1126:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    attrs: {
      "id": "career-opportunities"
    }
  }, [_c('h2', [_vm._v("Contact Information")]), _vm._v(" "), _c('p', [_c('b', [_c('code', {
    staticClass: "program-info",
    domProps: {
      "innerHTML": _vm._s(_vm.pointOfContact)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.phoneNumber) ? _c('a', {
    staticClass: "contact",
    attrs: {
      "target": "_parent",
      "href": _vm.phoneNumberM
    }
  }, [_vm._v(" " + _vm._s(_vm.phoneNumber))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.email) ? _c('a', {
    staticClass: "contact",
    attrs: {
      "target": "_parent",
      "href": 'mailto:' + _vm.email
    }
  }, [_vm._v(_vm._s(_vm.email))]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1127:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "majors"
    },
    on: {
      "click": function($event) {
        _vm.searching = false
      }
    }
  }, [_c('div', {
    staticClass: "ds-main ds-background",
    class: {
      'is-unm': _vm.$store.getters.isUnmMain
    },
    attrs: {
      "id": "landing-hero"
    }
  }, [_c('div', {
    attrs: {
      "id": "landing"
    }
  }, [_c('h1', [_vm._v("Find Your Degree")]), _vm._v(" "), _c('h2', [_vm._v("Explore our many programs of study to find the one that best fits you.")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "search-links"
    }
  }, [_c('div', {
    staticClass: "search-link-column"
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    }
  }, [_vm._v("\n            All Programs\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "search-link-column keyword-search",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.searching = true
      }
    }
  }, [(_vm.searching) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }, {
      name: "focus",
      rawName: "v-focus"
    }],
    ref: "searchBox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._m(0)]) : _c('a', {
    staticClass: "ds-main ds-color-hover search-link"
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v("\n            Find by Keyword\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "search-link-column"
  }, [_c('router-link', {
    staticClass: "ds-main ds-color-hover search-link",
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    }
  }, [_vm._v("\n            Search by Interest\n          ")])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}

/***/ }),

/***/ 1128:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'is-unm': _vm.$store.getters.isUnmMain
    },
    attrs: {
      "id": "search-by-keyword"
    }
  }, [_c('div', {
    attrs: {
      "id": "searchbar"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fas fa-search"
  })]), _vm._v(" "), _c('major-list', {
    attrs: {
      "majors": _vm.filteredMajors
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1129:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "units-by-college"
  }, [_c('div', {
    staticClass: "unit-college"
  }, [_vm._v(_vm._s((_vm.college.values[0].values[0].college || {}).name))]), _vm._v(" "), _c('div', {
    staticClass: "unit-items"
  }, _vm._l((_vm.college.values), function(program) {
    return _c('program', {
      key: program.key,
      attrs: {
        "program": program
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1130:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "aria-label": "unm footer",
      "id": "footer",
      "role": "contentinfo"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row unmfooter"
  }, [_c('div', {
    staticClass: "col-md-9 hidden-xs"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Academics"
    }
  }, [_c('h1', [_vm._v("Academics")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://unmevents.unm.edu/site/academic"
    }
  }, [_vm._v("Academic Calendars")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://schedule.unm.edu/"
    }
  }, [_vm._v("Class Schedule")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/academics/"
    }
  }, [_vm._v("Colleges & Schools")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://catalog.unm.edu/"
    }
  }, [_vm._v("Course Catalog")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://degrees.unm.edu/"
    }
  }, [_vm._v("Degrees & Certificates")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://grad.unm.edu/"
    }
  }, [_vm._v("Graduate Studies")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Campus Life"
    }
  }, [_c('h1', [_vm._v("Campus Life")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/arts/index.html"
    }
  }, [_vm._v("Arts & Entertainment")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.golobos.com"
    }
  }, [_vm._v("Athletics")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://diverse.unm.edu/"
    }
  }, [_vm._v("Diversity")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://recsvcs.unm.edu/"
    }
  }, [_vm._v("Recreational Services")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://sac.unm.edu"
    }
  }, [_vm._v("Student Activities")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://sub.unm.edu"
    }
  }, [_vm._v("Student Union")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Resources"
    }
  }, [_c('h1', [_vm._v("Resources")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://bookstore.unm.edu"
    }
  }, [_vm._v("Bookstore")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://computing.unm.edu"
    }
  }, [_vm._v("Computing")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://ce.unm.edu"
    }
  }, [_vm._v("Continuing Education")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://unmjobs.unm.edu"
    }
  }, [_vm._v("Employment")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/libraries/"
    }
  }, [_vm._v("Libraries")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://news.unm.edu"
    }
  }, [_vm._v("UNM Newsroom")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3",
    attrs: {
      "aria-label": "Information for..."
    }
  }, [_c('h1', [_vm._v("Information for…")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.unmalumni.com/"
    }
  }, [_vm._v("Alumni")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/facultyandstaff/"
    }
  }, [_vm._v("Faculty")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/parents-families/index.html"
    }
  }, [_vm._v("Parents & Families")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://hospitals.unm.edu"
    }
  }, [_vm._v("Patients")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://publicrecords.unm.edu/"
    }
  }, [_vm._v("Public Records - IPRA")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/facultyandstaff/"
    }
  }, [_vm._v("Staff")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://executivesearch.unm.edu/evp-for-health-sciences/index.html"
    }
  }, [_vm._v("EVP for Health Sciences\n                  Search")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 footer-buttons"
  }, [_c('a', {
    staticClass: "btn btn-default btn-lg btn-block",
    attrs: {
      "href": "https://www.unm.edu/apply"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "fa-check fa"
  }, [_vm._v(" ")]), _vm._v(" APPLY")]), _vm._v(" Now")]), _c('a', {
    staticClass: "btn btn-default btn-lg btn-block",
    attrs: {
      "href": "https://admissions.unm.edu/visit-us/"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "fa-calendar fa"
  }, [_vm._v(" ")]), _vm._v(" Visit")]), _vm._v(" UNM")]), _c('a', {
    staticClass: "btn btn-default btn-lg btn-block",
    attrs: {
      "href": "https://www.unmfund.org/"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "fa-gift fa"
  }, [_vm._v(" ")]), _vm._v(" Give")]), _vm._v(" to UNM")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu"
    }
  }, [_c('img', {
    attrs: {
      "alt": "The University of New Mexico",
      "src": "https://webcore.unm.edu/v2/images/unm-transparent-white.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "small"
  }, [_vm._v("© The University of New Mexico "), _c('br'), _vm._v(" Albuquerque, NM 87131, (505) 277-0111 "), _c('br'), _vm._v(" New Mexico's\n          Flagship University")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/universityofnewmexico",
      "title": "UNM on Facebook"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-facebook fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on Facebook")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://instagram.com/uofnm",
      "title": "UNM on Instagram"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-instagram fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on Instagram")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://twitter.com/unm",
      "title": "UNM on Twitter"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-x-twitter fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on Twitter")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.youtube.com/user/unmlive",
      "title": "UNM on YouTube"
    }
  }, [_c('i', {
    staticClass: "fa-brands fa-youtube fa-2x"
  }), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("UNM on YouTube")])])])]), _vm._v(" "), _c('p', [_vm._v("more at "), _c('a', {
    staticClass: "link-underline",
    attrs: {
      "href": "https://social.unm.edu",
      "title": "UNM Social Media Directory & Information"
    }
  }, [_vm._v("social.unm.edu")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline",
    attrs: {
      "id": "unm_footer_links"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "http://webmaster.unm.edu/support"
    }
  }, [_vm._v("Website Comments")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/accessibility.html"
    }
  }, [_vm._v("Accessibility")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/legal.html"
    }
  }, [_vm._v("Legal")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/contactunm.html"
    }
  }, [_vm._v("Contact UNM")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.unm.edu/consumer-information/"
    }
  }, [_vm._v("Consumer Information")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://hed.state.nm.us/resources-for-schools/public_schools/tableau-charts-and-tables"
    }
  }, [_vm._v("New\n              Mexico Higher Education Dashboard")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://finaid.unm.edu/cares-act.html"
    }
  }, [_vm._v("CARES Act")])])])])])])])
}]}

/***/ }),

/***/ 1131:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "interest-search"
    }
  }, [(_vm.currentArea) ? _c('div', {
    staticClass: "ds-main ds-border",
    class: {
      'show-majors': _vm.selected
    },
    attrs: {
      "id": "carousel"
    }
  }, [_c('img', {
    staticClass: "slide-img",
    attrs: {
      "src": _vm.currentArea.large_image_url
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.previousArea
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "slide-info"
  }, [_c('h1', [_vm._v(_vm._s(_vm.currentArea.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.currentArea.definition))]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.selected = true
      }
    }
  }, [_vm._v("See Majors")])]) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.selected) ? _c('div', {
    staticClass: "arrow",
    on: {
      "click": _vm.nextArea
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "carousel-swiper"
    }
  }, [_c('swiper', {
    ref: "swiper",
    attrs: {
      "options": _vm.swiperOptions,
      "not-next-tick": _vm.notNextTick
    }
  }, _vm._l((_vm.interestAreas), function(area, i) {
    return _c('swiper-slide', {
      key: i
    }, [_c('div', {
      staticClass: "swiper-content ds-main ds-border",
      class: {
        'current-area': area === _vm.currentArea
      },
      on: {
        "click": function($event) {
          return _vm.swiperClick(area, i)
        }
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "swiper-img",
      attrs: {
        "src": area.large_image_url
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "swiper-img",
      attrs: {
        "src": area.medium_image_url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "swiper-title"
    }, [_vm._v("\n              " + _vm._s(area.name) + "\n            ")])])])
  }), 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "carousel-back"
    }
  }, [(_vm.selected) ? _c('div', {
    staticClass: "carousel-back ds-main ds-background",
    on: {
      "click": function($event) {
        _vm.selected = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.selected) ? _c('div', {
    attrs: {
      "id": "interest-majors"
    }
  }, [_c('major-list', {
    attrs: {
      "majors": _vm.currentMajors
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1132:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    class: {
      "concentration-line": _vm.unit.type === "concentration"
    }
  }), _vm._v(" "), (_vm.unit.type === "concentration") ? _c('i', {
    staticClass: "fas fa-circle concentration-icon"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-name"
  }, [_c('div', {
    staticClass: "unit-name-wrap"
  }, [_c('div', {
    staticClass: "unit-type"
  }, [_vm._v(_vm._s(_vm.unit.type))]), _vm._v("\n          " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), (_vm.active) ? [_c('div', {
    staticClass: "unit-level"
  }, [(_vm.level) ? _c('span', [_vm._v(_vm._s(_vm.level))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-period-select"
  }, [(_vm.unit.planPeriods.length > 0) ? _c('multiselect', {
    attrs: {
      "options": _vm.unit.planPeriods,
      "track-by": "id",
      "label": "name",
      "selected-label": "",
      "deselect-label": "",
      "select-label": "",
      "placeholder": "Select Period"
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }) : _c('span', [_vm._v(" ")])], 1)] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1133:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "unit-content"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    class: {
      "concentration-line": _vm.unit.type === "concentration"
    }
  }), _vm._v(" "), (_vm.unit.type === "concentration") ? _c('i', {
    staticClass: "concentration-icon fas fa-circle"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "unit-name",
    style: (_vm.nameStyle),
    on: {
      "click": _vm.goToPlans
    }
  }, [_c('div', {
    staticClass: "unit-name-wrap"
  }, [_c('div', {
    staticClass: "unit-type"
  }, [_vm._v(_vm._s(_vm.unit.type))]), _vm._v("\n          " + _vm._s(_vm.label) + "\n        ")])]), _vm._v(" "), (_vm.active) ? [_c('div', {
    staticClass: "unit-level"
  }, [(_vm.level) ? _c('span', [_vm._v(_vm._s(_vm.level))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-availability"
  }, [(_vm.onlineAvailability) ? _c('span', [_vm._v(_vm._s(_vm.onlineAvailability))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-plans"
  }, [(_vm.planPeriod) ? _c('span', [_vm._v(_vm._s(_vm.planCount) + " " + _vm._s(_vm.planString))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-credits"
  }, [(_vm.planPeriod) ? _c('span', [_vm._v(_vm._s(_vm.planPeriod.major_credits) + " Credits")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "unit-buttons"
  }, [(_vm.unit.has_info || _vm.unit.cip_code) ? _c('router-link', {
    attrs: {
      "to": {
        name: "unit-info",
        params: _vm.unitParams
      }
    }
  }, [_c('button', {
    staticClass: "hollow"
  }, [_vm._v("Info")])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "unit-buttons"
  }, [(_vm.planPeriod) ? _c('router-link', {
    attrs: {
      "to": {
        name: "unit-plans",
        params: _vm.unitParams
      }
    }
  }, [_c('button', {
    staticClass: "hollow"
  }, [_vm._v(_vm._s(_vm.planString))])]) : _vm._e()], 1)] : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1134:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view')
},staticRenderFns: []}

/***/ }),

/***/ 1135:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wildcard-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "wildcard-name"
  }, [_vm._v(_vm._s(_vm.req.name))]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [_vm._v("Credit Hours:\n      "), (_vm.req.minimum_credits === _vm.req.maximum_credits) ? [_vm._v("\n        " + _vm._s(_vm.req.minimum_credits) + "\n      ")] : [_vm._v("\n        " + _vm._s(_vm.req.minimum_credits) + " - " + _vm._s(_vm.req.maximum_credits) + "\n      ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })])])
},staticRenderFns: []}

/***/ }),

/***/ 1136:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "swiper-container"
  }, [_vm._t("parallax-bg"), _vm._v(" "), _c('div', {
    class: _vm.defaultSwiperClasses.wrapperClass
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("pagination"), _vm._v(" "), _vm._t("button-prev"), _vm._v(" "), _vm._t("button-next"), _vm._v(" "), _vm._t("scrollbar")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 1137:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unitPeriod) ? _c('span', {
    attrs: {
      "id": "plans"
    }
  }, [_c('div', {
    attrs: {
      "id": "plan-tabs"
    }
  }, [(_vm.plans.length > 1) ? _c('ul', _vm._l((_vm.plans), function(plan, index) {
    return _c('li', {
      key: plan.id,
      staticClass: "ds-main ds-color ds-border-color plan-tab",
      class: {
        inactive: _vm.activePlan != plan
      },
      on: {
        "click": function($event) {
          _vm.activePlanIndex = index, _vm.expand = false
        }
      }
    }, [_c('div', {
      staticClass: "plan-tab-name"
    }, [_vm._v(_vm._s(plan.plan.name))])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.planNotes && _vm.planNotes.length > 0) ? _c('div', {
    staticClass: "plan-notes",
    class: {
      infocollapse: _vm.setCollapse
    }
  }, [_c('ul', {
    staticClass: "fa-ul"
  }, _vm._l((_vm.planNotes), function(note) {
    return _c('li', {
      key: note.id
    }, [_vm._m(0, true), _vm._v(" "), _c('div', [_vm._v(_vm._s(note.note))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "plan-notes-button"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expand),
      expression: "!expand"
    }],
    staticClass: "ellipsis",
    on: {
      "click": _vm.setExpand
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expand),
      expression: "expand"
    }],
    staticClass: "ellipsis",
    on: {
      "click": _vm.setCollapseBack
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-types"
  }, _vm._l((_vm.planTypes), function(pt) {
    return _c('div', {
      key: pt[0],
      staticClass: "plan-type ds-main ds-color",
      class: {
        selected: _vm.selectedPlanType === pt,
        "ds-background": _vm.selectedPlanType === pt
      },
      on: {
        "click": function($event) {
          _vm.selectedPlanType = pt
        }
      }
    }, [_c('i', {
      staticClass: "fas",
      class: pt[1]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(pt[0]))])])
  }), 0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "up-down",
      "mode": "out-in"
    }
  }, [_vm._l((_vm.plans), function(plan) {
    return [(_vm.activePlan === plan) ? _c(_vm.selectedPlanType[0], {
      key: plan.id,
      tag: "component",
      attrs: {
        "termIdentifier": _vm.termIdentifier,
        "terms": _vm.formatTerms(plan.plan_terms),
        "special-requirements": _vm.specialRequirements
      }
    }) : _vm._e()]
  })], 2)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-li"
  }, [_c('i', {
    staticClass: "fas fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}

/***/ }),

/***/ 1138:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "degree-requirement req"
  }, [_c('div', {
    staticClass: "reqinfo"
  }, [_c('div', {
    staticClass: "requirement-name",
    on: {
      "click": function($event) {
        _vm.showSubreqs = !_vm.showSubreqs
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.req.name) + "\n      "), _c('i', {
    staticClass: "toggle-nested fa fa-caret-right",
    class: {
      'fa-rotate-90': _vm.showSubreqs
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "req-item"
  }, [(_vm.req.advanced) ? [_c('div', {
    staticClass: "req-satisfy variable blue"
  }, [_vm._v("Satisfy " + _vm._s(_vm.req.required) + " of " + _vm._s(_vm.subrequirements))]), _c('div', {
    staticClass: "req-satisfy credits blue"
  }, [_vm._v(_vm._s(_vm.req.minimum_credits) + " - " + _vm._s(_vm.req.maximum_credits) + " CR")])] : [_c('div', {
    staticClass: "req-satisfy variable"
  }, [_vm._v(_vm._s(_vm.req.minimum_credits) + " CR")]), _c('div', {
    staticClass: "req-satisfy credits"
  }, [_vm._v("Satisfy " + _vm._s(_vm.req.required) + " of " + _vm._s(_vm.subrequirements))])]], 2), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSubreqs),
      expression: "showSubreqs"
    }],
    staticClass: "subrequirements"
  }, _vm._l((_vm.req.subrequirements), function(req) {
    return _c('requirement', {
      key: req.id,
      ref: "requirements",
      refInFor: true,
      attrs: {
        "req": req
      }
    })
  }), 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unit) ? _c('div', {
    attrs: {
      "id": "unit-info"
    }
  }, [_c('transition', {
    attrs: {
      "name": "up-down",
      "mode": "out-in"
    }
  }, [(_vm.hasInfo) ? _c('div', [(_vm.unit && _vm.unit.description) ? _c('program-information') : _vm._e(), _vm._v(" "), (_vm.unit.cip_code) ? _c('career-opportunities', {
    attrs: {
      "cip": _vm.unit.cip_code
    }
  }) : _vm._e(), _vm._v(" "), (_vm.unit && _vm.unit.point_of_contact) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.unit && _vm.unit.point_of_contact) ? _c('contact-information') : _vm._e()], 1) : _c('div', [_vm._v("\n      No additional program information.\n    ")])])], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_vm._v("\n    " + _vm._s(_vm.occupation.title) + "\n    "), (_vm.occupation.tags.green) ? [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "<span>Green</span> Occupation",
        offset: 5,
        classes: "green-tooltip"
      }),
      expression: "{ content: \"<span>Green</span> Occupation\", offset: 5, classes: \"green-tooltip\" }",
      modifiers: {
        "top-center": true
      }
    }],
    attrs: {
      "src": __webpack_require__(397),
      "height": "14"
    }
  })] : _vm._e(), _vm._v(" "), (_vm.occupation.tags.bright_outlook) ? [_c('img', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "<span>Bright</span> Outlook",
        offset: 5,
        classes: "bright-outlook-tooltip"
      }),
      expression: "{ content: \"<span>Bright</span> Outlook\", offset: 5, classes: \"bright-outlook-tooltip\" }",
      modifiers: {
        "top-center": true
      }
    }],
    attrs: {
      "src": __webpack_require__(396),
      "height": "14"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.dollars(_vm.occupation.salary.annual_median)))]), _vm._v(" "), _c('td', {
    staticClass: "salary-cell"
  }, [_c('div', {
    staticClass: "salary-occupation"
  }, [_c('div', {
    staticClass: "salary-labels"
  }, [_c('div', {
    staticClass: "salary-label salary-min",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary10th)
    })
  }, [_vm._v("\n          " + _vm._s(_vm.dollars2(_vm.salary10th)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "salary-label salary-median",
    style: ({
      left: _vm.getSalaryOffset(_vm.salaryMedian)
    })
  }, [_vm._v("\n          " + _vm._s(_vm.dollars2(_vm.salaryMedian)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "salary-label salary-max",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary90th)
    })
  }, [_vm._v("\n          " + _vm._s(_vm.dollars2(_vm.salary90th)) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "salary-markers"
  }, [_c('div', {
    staticClass: "salary-domain salary-marker-outer ds-border ds-main",
    style: (_vm.rangeStyles)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "Annual 10th Percentile",
        offset: 5
      }),
      expression: "{ content: \"Annual 10th Percentile\", offset: 5 }",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "salary-marker salary-marker-outer ds-border ds-main",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary10th)
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "Annual Median",
        offset: 5
      }),
      expression: "{ content: \"Annual Median\", offset: 5 }",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "salary-marker ds-border ds-main",
    style: ({
      left: _vm.getSalaryOffset(_vm.salaryMedian)
    })
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top-center",
      value: ({
        content: "Annual 90th Percentile",
        offset: 5
      }),
      expression: "{ content: \"Annual 90th Percentile\", offset: 5 }",
      modifiers: {
        "top-center": true
      }
    }],
    staticClass: "salary-marker salary-marker-outer ds-border ds-main",
    style: ({
      left: _vm.getSalaryOffset(_vm.salary90th)
    })
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "unm-header"
  }, [_c('div', {
    staticClass: "navbar navbar-unm"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "https://degrees.unm.edu"
    }
  }, [_vm._v("The University of New\n        Mexico")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right hidden-xs",
    attrs: {
      "id": "toolbar-nav"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu/departments/",
      "title": "UNM A to Z"
    }
  }, [_vm._v("UNM A-Z")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://my.unm.edu",
      "title": "myUNM"
    }
  }, [_vm._v("myUNM")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu",
      "title": "Directory"
    }
  }, [_vm._v("Directory")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "department logo block",
      "id": "header",
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  })])])
}]}

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 397:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(1123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 399:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return http; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_axios___default.a; });


var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://s3-us-west-2.amazonaws.com/rpsp-university-assets/json"
});

/* unused harmony default export */ var _unused_webpack_default_export = (http);


/***/ }),

/***/ 400:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_University__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_University___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_University__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Landing__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_InterestSearch__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_InterestSearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__views_InterestSearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Unit__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_Unit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__views_Unit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_UnitPeriod__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_UnitPeriod___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__views_UnitPeriod__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_UnitPlans__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_UnitPlans___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__views_UnitPlans__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_UnitInfo__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_UnitInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__views_UnitInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_PageContent__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_PageContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__views_PageContent__);





// import CollegeSearch from '@/views/CollegeSearch'







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // turn off history mode for now due to s3 deployment
  mode: 'history',
  routes: [{
    path: '',
    component: __WEBPACK_IMPORTED_MODULE_2__views_University___default.a,
    children: [{
      path: '',
      name: 'landing',
      component: __WEBPACK_IMPORTED_MODULE_3__views_Landing___default.a
    }, {
      path: '',
      component: __WEBPACK_IMPORTED_MODULE_10__views_PageContent___default.a,
      children: [{
        path: 'name_search',
        name: 'nameSearch',
        component: __WEBPACK_IMPORTED_MODULE_4__views_KeywordSearch___default.a
      },
      // {
      //   path: 'college_search',
      //   name: 'collegeSearch',
      //   component: CollegeSearch
      // },
      {
        path: 'interest_search',
        name: 'interestSearch',
        component: __WEBPACK_IMPORTED_MODULE_5__views_InterestSearch___default.a
      }, {
        path: 'units/:layout_id',
        component: __WEBPACK_IMPORTED_MODULE_6__views_Unit___default.a,
        children: [{
          path: '',
          name: 'unit-info',
          component: __WEBPACK_IMPORTED_MODULE_9__views_UnitInfo___default.a
        }, {
          path: 'periods/:period_id',
          component: __WEBPACK_IMPORTED_MODULE_7__views_UnitPeriod___default.a,
          children: [{
            path: 'plans',
            name: 'unit-plans',
            component: __WEBPACK_IMPORTED_MODULE_8__views_UnitPlans___default.a
          }]
        }]
        // {
        //   path: 'periods/:period_id/units/:layout_id',
        //   component: Unit,
        //   children: [
        //     {
        //       path: 'plans',
        //       name: 'unit-plans',
        //       component: UnitPlans
        //     }
        //   ]
        // }
      }]
    }]
  }],

  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
}));

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loaded: false,
    university: {},
    layouts: [],
    periods: [],
    showArchived: false,
    selectedTermItem: null,
    unit: null,
    unitPeriod: null,
    id: "mesalands-community-college",
    selectedProgramLevel: 'All'
    // majors: []
    // interestAreas: [],
  },

  mutations: {
    setUniversity: function setUniversity(state, u) {
      state.university = u;
    },
    setLayouts: function setLayouts(state, l) {
      state.layouts = l;
      state.loaded = true;
    },
    setPeriods: function setPeriods(state, p) {
      state.periods = p;
    },
    setShowArchived: function setShowArchived(state, s) {
      state.showArchived = s;
    },
    setSelectedTermItem: function setSelectedTermItem(state, i) {
      state.selectedTermItem = i;
    },
    setUnit: function setUnit(state, u) {
      state.unit = u;
    },
    setUnitPeriod: function setUnitPeriod(state, u) {
      state.unitPeriod = u;
    },
    setSelectedProgramLevel: function setSelectedProgramLevel(state, pl) {
      state.selectedProgramLevel = pl;
    }
  },

  getters: {
    isUnmMain: function isUnmMain(state) {
      console.log(state.university);
      return state.university && state.university.id == 4158;
    },


    // format program and concentrations as a set of "majors"
    majors: function majors(state, getters) {
      return state.layouts.map(function (layout) {
        // make sure plan periods only include academic_periods that
        // are also in the list of university periods
        layout.planPeriods = layout.academic_periods.filter(function (p) {
          return getters.periodIds.includes(p.id) && p.plan_count;
        });

        layout.planPeriods.forEach(function (p) {
          p.name = state.periods.find(function (period) {
            return period.id === p.id;
          }).name;
        });

        layout.planPeriods.sort(function (a, b) {
          return a.id - b.id;
        });

        layout.planPeriodIds = layout.planPeriods.map(function (p) {
          return p.id;
        });

        layout.currentPlanPeriod = layout.planPeriods.find(function (p) {
          return p.id === getters.currentPeriod.id;
        });

        layout.currentAcademicPeriod = layout.academic_periods.find(function (p) {
          return p.id === getters.currentPeriod.id;
        });

        return layout;
      }).filter(function (layout) {
        var typeCheck = ['program', 'concentration'].includes(layout.type);
        // const planCheck = layout.planPeriodIds.length

        return typeCheck;
      });
    },
    termIdentifier: function termIdentifier(state) {
      return state.university.term_identifier || 'Term';
    },


    // return current majors unless the showArchived flag is true
    currentMajors: function currentMajors(state, getters) {
      var majors = getters.majors;
      return (state.showArchived ? majors : majors.filter(function (m) {
        return !!m.currentAcademicPeriod;
      })) || [];
    },


    // get latest period
    currentPeriod: function currentPeriod(state) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["maxBy"])(state.periods, function (p) {
        return p.code;
      }) || {};
    },


    // get a map of period ids
    periodIds: function periodIds(state) {
      return state.periods.map(function (p) {
        return p.id;
      });
    },
    unitMajor: function unitMajor(state) {
      if (!state.unitPeriod) return null;
      return state.unitPeriod.period_degree_joins.find(function (pdj) {
        return pdj.degree_type.code === 'MAJOR';
      });
    },
    unitMinor: function unitMinor(state) {
      if (!state.unitPeriod) return null;
      return state.unitPeriod.period_degree_joins.find(function (pdj) {
        return pdj.degree_type.code === 'MINOR';
      });
    }
  }
});

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 404:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(995)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(1115),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(1121),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_requirement_vue__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_requirement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__http__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_v_tooltip__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_modal__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_js_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_js_modal__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// Import styles
__webpack_require__(404);
__webpack_require__(403);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

// Make Axios global
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_8__http__["a" /* axios */];

// AXIOS with base s3 url set
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$http = __WEBPACK_IMPORTED_MODULE_8__http__["b" /* http */];

// Global components
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('multiselect', __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('requirement', __WEBPACK_IMPORTED_MODULE_6__components_requirement_vue___default.a);

// Directives
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

// Setup vue modal
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_12_vue_js_modal___default.a);

// Setup Vuex store
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store(__WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */]);

// Setup VueAwesomeSwiper store
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_awesome_swiper___default.a);

// setup v-tooltip
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_11_v_tooltip__["a" /* default */]);

// Setup Vue Analytics
if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_analytics___default.a, {
    id: "UA-99172454-8",
    router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
    set: [{ field: 'dimension1', value: "mesalands-community-college" }, { field: 'dimension2', value: getPeriod() }]
  });
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

function getPeriod() {
  var date = new Date();
  var year = date.getFullYear();

  switch (date.getMonth()) {
    case 11:
    case 0:
      return 'Winter ' + year;
    case 1:
    case 2:
    case 3:
    case 4:
      return 'Spring ' + year;
    case 5:
    case 6:
      return 'Summer ' + year;
    case 7:
    case 8:
    case 9:
    case 10:
      return 'Fall ' + year;
  }
}

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper-slide',
  data: function data() {
    return {
      slideClass: 'swiper-slide'
    };
  },
  ready: function ready() {
    this.update();
  },
  mounted: function mounted() {
    this.update();
    if (this.$parent.options.slideClass) {
      this.slideClass = this.$parent.options.slideClass;
    }
  },
  updated: function updated() {
    this.update();
  },
  attached: function attached() {
    this.update();
  },
  methods: {
    update: function update() {
      if (this.$parent && this.$parent.swiper && this.$parent.swiper.update) {
        this.$parent.swiper.update(true);
        if (this.$parent.options.loop) {
          this.$parent.swiper.reLoop();
        }
      }
    }
  }
});

/***/ }),

/***/ 435:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

var browser = typeof window !== 'undefined';
if (browser) window.Swiper = __webpack_require__(395);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'swiper',
  props: {
    options: {
      type: Object,
      default: function _default() {
        return {
          autoplay: 3500
        };
      }
    },
    notNextTick: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      defaultSwiperClasses: {
        wrapperClass: 'swiper-wrapper'
      }
    };
  },
  ready: function ready() {
    if (!this.swiper && browser) {
      this.swiper = new Swiper(this.$el, this.options);
    }
  },
  mounted: function mounted() {
    var self = this;
    var mount = function () {
      if (!self.swiper && browser) {
        delete self.options.notNextTick;
        var setClassName = false;
        for (var className in self.defaultSwiperClasses) {
          if (self.defaultSwiperClasses.hasOwnProperty(className)) {
            if (self.options[className]) {
              setClassName = true;
              self.defaultSwiperClasses[className] = self.options[className];
            }
          }
        }
        var mountInstance = function mountInstance() {
          self.swiper = new Swiper(self.$el, self.options);
        };
        setClassName ? self.$nextTick(mountInstance) : mountInstance();
      }
    }(this.options.notNextTick || this.notNextTick) ? mount() : this.$nextTick(mount);
  },
  updated: function updated() {
    if (this.swiper) {
      this.swiper.update();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy();
      delete this.swiper;
    }
  }
});

/***/ }),

/***/ 436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

document.addEventListener('touchstart', function () {}, true);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  methods: {
    openFeedback: function openFeedback() {
      window.open(this.feedbackUrl);
    }
  },
  computed: {
    feedbackUrl: function feedbackUrl() {
      return this.$store.state.university.feedback_url;
    }
  }
});

/***/ }),

/***/ 437:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__occupation__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__occupation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__occupation__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var defaultCareerData = { occupations: [] };

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CareerOpportunities',

  data: function data() {
    return {
      dollars: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])('$.2s'),
      careerData: defaultCareerData
    };
  },
  created: function created() {
    this.fetchData();
  },


  watch: {
    '$route': 'fetchData'
  },

  props: {
    cip: {
      required: true,
      type: Object
    }
  },

  computed: {
    salaryMin: function salaryMin() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3__["a" /* min */])(this.occupations, function (o) {
        return o.salary.annual_10th_percentile;
      });
    },
    salaryMax: function salaryMax() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3__["b" /* max */])(this.occupations, function (o) {
        return o.salary.annual_90th_percentile || o.salary.annual_90th_percentile_over;
      });
    },
    salaryMid: function salaryMid() {
      return (this.salaryMin + this.salaryMax) / 2;
    },
    salaryRange: function salaryRange() {
      return this.salaryMax - this.salaryMin;
    },
    occupations: function occupations() {
      return this.careerData.occupations.filter(function (o) {
        return o.salary;
      });
    },
    showGreenLegend: function showGreenLegend() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["some"])(this.careerData.occupations, function (o) {
        return o.tags.green;
      });
    },
    showBrightOutlookLegend: function showBrightOutlookLegend() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash__["some"])(this.careerData.occupations, function (o) {
        return o.tags.bright_outlook;
      });
    }
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.careerData = defaultCareerData;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_axios__["get"])('https://careers.nmrpsp.org/cips/' + this.cip.code).then(function (response) {
        _this.careerData = response.data || defaultCareerData;
      });
    }
  },

  components: {
    Occupation: __WEBPACK_IMPORTED_MODULE_4__occupation___default.a
  }
});

/***/ }),

/***/ 438:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__program_vue__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__program_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__program_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['college'],
  components: {
    Program: __WEBPACK_IMPORTED_MODULE_0__program_vue___default.a
  }
});

/***/ }),

/***/ 439:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// const defaultCareerData = { occupations: [] }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ContactInformation',

  data: function data() {
    return {};
  },


  computed: {
    unit: function unit() {
      return this.$store.state.unit;
    },
    pointOfContact: function pointOfContact() {
      return this.unit.point_of_contact;
    },
    phoneNumber: function phoneNumber() {
      return this.unit.phone_number;
    },
    phoneNumberM: function phoneNumberM() {
      return 'tel: ' + this.unit.phone_number.replace(/[^\w\s]/gi, '');
    },
    email: function email() {
      return this.unit.email;
    }
  },

  methods: {}
});

/***/ }),

/***/ 440:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_course_requisite__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_course_requisite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_course_requisite__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'course',

  // Properties
  // Req - The requirement object
  props: ['req'],

  components: {
    RequisitesString: __WEBPACK_IMPORTED_MODULE_0_vue_course_requisite__["RequisitesString"]
  },

  methods: {
    // used to roll credit count up to parent requirement sets
    computeMinimumCredits: function computeMinimumCredits() {
      return this.req.credits;
    }
  },

  computed: {
    name: function name() {
      var course = this.req.course;
      return course.name === course.full_number ? course.name : course.full_number + ' - ' + course.name;
    }
  }
});

/***/ }),

/***/ 441:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'degree-requirement',

  // Properties
  // Req - The requirement object
  props: ['req'],

  data: function data() {
    return {
      showSubreqs: true // Flag to show or hide subrequrements
    };
  },
  mounted: function mounted() {
    // If the minimum credit hours differ from the minimum credit hours
    // based on subrequirements and satisfy value, then set the variable
    // flag to true
    // let sc = this.computeMinimumCredits()
    // if (sc != this.req.minimum_credits) {
    //   this.variable = true
    // }
  },


  computed: {
    // Number of subrequirements
    subrequirements: function subrequirements() {
      return this.req.subrequirements.length;
    }
  },

  methods: {
    // Set the collapse state of instance requirement and children
    setCollapseState: function setCollapseState(state) {
      this.showSubreqs = state;
      this.$refs.requirements.forEach(function (r) {
        return r.setCollapseState(state);
      });
    },

    // used to roll credit count up to parent requirement sets
    computeMinimumCredits: function computeMinimumCredits() {
      if (this.advanced) {
        return this.req.minimum_credits;
      } else if (this.$refs.requirements) {
        var credits = this.$refs.requirements.map(function (req) {
          return req.computeMinimumCredits();
        }).sort(function (a, b) {
          return a - b;
        });
        this.req.minimum_credits = this.req.maximum_credits = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["sum"])(credits.slice(0, this.req.required));
        return this.req.minimum_credits;
      } else {
        this.req.minimum_credits = 0;
        return this.req.minimum_credits;
      }
    }
  }
});

/***/ }),

/***/ 442:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__college_vue__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__college_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__college_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'MajorList',

  data: function data() {
    // get a sortable key by removing any 2+ character sets of capital
    // letters or any symbols. If all characters are removed, fallback to
    // original string. Also append first character so that programs starting
    // with AS come before those with BS.
    var sortKey = function sortKey(string) {
      return string[0] + string.replace(/[A-Z]{2,}|[ \-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, ''); // eslint-disable-line no-useless-escape
    };

    var sortAscending = function sortAscending(a, b) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["d" /* ascending */])(sortKey(a), sortKey(b));
    };

    return {
      headerFixed: false,
      nest: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["e" /* nest */])().key(function (d) {
        return '' + (d.college || {}).name + (d.college || {}).code;
      }).sortKeys(__WEBPACK_IMPORTED_MODULE_0_d3__["d" /* ascending */]).key(function (d) {
        return '' + (d.program || {}).name + (d.program || {}).code;
      }).sortKeys(sortAscending)
    };
  },


  props: {
    majors: {
      requred: true
    }
  },

  created: function created() {
    window.addEventListener('scroll', this.headerFixedCheck);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.headerFixedCheck);
  },


  computed: {
    currentPeriod: function currentPeriod() {
      return this.$store.getters.currentPeriod;
    },
    showArchived: function showArchived() {
      return this.$store.state.showArchived;
    },
    selectedProgramLevel: function selectedProgramLevel() {
      return this.$store.state.selectedProgramLevel;
    },
    programLevelMajors: function programLevelMajors() {
      var _this = this;

      if (this.selectedProgramLevel === 'All') {
        return this.majors;
      } else {
        return this.majors.filter(function (m) {
          return m.program_level && m.program_level.name === _this.selectedProgramLevel;
        });
      }
    },
    nestedMajors: function nestedMajors() {
      return this.nest.entries(this.programLevelMajors);
    }
  },

  methods: {
    toggleArchived: function toggleArchived() {
      this.$store.commit('setShowArchived', !this.showArchived);
    },
    headerFixedCheck: function headerFixedCheck() {
      this.headerFixed = this.$store.getters.isUnmMain ? this.$refs.headerPlaceholder.getBoundingClientRect().y < 70 : this.$refs.headerPlaceholder.getBoundingClientRect().y < 50;
    }
  },

  components: {
    College: __WEBPACK_IMPORTED_MODULE_1__college_vue___default.a
  }
});

/***/ }),

/***/ 443:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(137);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    occupation: {
      type: Object,
      required: true
    },

    salaryMin: {
      type: Number,
      required: true
    },

    salaryRange: {
      type: Number,
      required: true
    }
  },

  data: function data() {
    return {
      dollars: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["c" /* format */])('$,'),
      dollars2: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["c" /* format */])('$.2s')
    };
  },


  computed: {
    salary10th: function salary10th() {
      return this.occupation.salary.annual_10th_percentile;
    },
    salaryMedian: function salaryMedian() {
      return this.occupation.salary.annual_median;
    },
    salary90th: function salary90th() {
      return this.occupation.salary.annual_90th_percentile || this.occupation.salary.annual_90th_percentile_over;
    },
    rangeStyles: function rangeStyles() {
      return {
        left: this.getSalaryOffset(this.salary10th),
        width: 100 * (this.salary90th - this.salary10th) / this.salaryRange + '%'
      };
    }
  },

  methods: {
    getSalaryOffset: function getSalaryOffset(salary) {
      return 100 * (salary - this.salaryMin) / this.salaryRange + '%';
    }
  }
});

/***/ }),

/***/ 444:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_vue__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__unit_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['program'],

  components: {
    Unit: __WEBPACK_IMPORTED_MODULE_1__unit_vue___default.a
  },

  computed: {
    inactiveUnit: function inactiveUnit() {
      return {
        inactive: true,
        type: 'program',
        program: this.program.values[0].program
      };
    },
    unit: function unit() {
      return this.programs[0] || this.inactiveUnit;
    },
    concentrations: function concentrations() {
      return this.program.values.filter(function (v) {
        return v.type === 'concentration';
      }).sort(function (a, b) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["d" /* ascending */])((a[a.type] || {}).name, (b[b.type] || {}).name);
      });
    },
    programs: function programs() {
      return this.program.values.filter(function (v) {
        return v.type === 'program';
      }).sort(function (a, b) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3__["d" /* ascending */])((a[a.type] || {}).name, (b[b.type] || {}).name);
      });
    },
    programsWithPlans: function programsWithPlans() {
      return this.programs.filter(function (p) {
        return p.currentPlanPeriod;
      });
    },
    programsToShow: function programsToShow() {
      return this.programsWithPlans.length ? this.programsWithPlans : [this.unit];
    },
    hasPlans: function hasPlans() {
      return this.showArchived ? this.program.values.find(function (u) {
        return u.planPeriods.length;
      }) : this.program.values.find(function (u) {
        return u.currentPlanPeriod;
      });
    },
    showArchived: function showArchived() {
      return this.$store.state.showArchived;
    }
  }
});

/***/ }),

/***/ 445:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//


// const defaultCareerData = { occupations: [] }

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ProgramInformation',

  data: function data() {
    return {};
  },


  computed: {
    unit: function unit() {
      return this.$store.state.unit;
    },
    informationType: function informationType() {
      return this.unit.type;
    },
    programInfo: function programInfo() {
      return this.unit.description;
    },
    onlineAvailability: function onlineAvailability() {
      return this.unit.online_availability;
    },
    planName: function planName() {
      if (typeof this.unit.concentration === 'undefined') {
        return this.unit.program.name;
      } else {
        return this.unit.program.name + ': ' + this.unit.concentration.name;
      }
    },
    planType: function planType() {
      return this.unit.concentration ? 'Concentration' : 'Program';
    }
  },

  methods: {}
});

/***/ }),

/***/ 446:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__course_requirement_vue__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__course_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__course_requirement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'requirement',

  props: {
    req: true
  },

  components: {
    DegreeRequirement: __WEBPACK_IMPORTED_MODULE_0__degree_requirement_vue___default.a,
    Course: __WEBPACK_IMPORTED_MODULE_1__course_requirement_vue___default.a,
    Wildcard: __WEBPACK_IMPORTED_MODULE_2__wild_card_requirement_vue___default.a
  },

  methods: {
    mainRef: function mainRef() {
      return this.$refs.coreRequirement || this.$refs.degreeRequirement || this.$refs.courseRequirement || this.$refs.wildCardRequirement;
    },
    nestedRef: function nestedRef() {
      return this.$refs.degreeRequirement || this.$refs.coreRequirement;
    },
    setCollapseState: function setCollapseState(state) {
      var ref = this.nestedRef();
      if (ref) ref.setCollapseState(state);
    },
    computeMinimumCredits: function computeMinimumCredits() {
      var ref = this.mainRef();
      return ref ? ref.computeMinimumCredits() || 0 : 0;
    }
  }
});

/***/ }),

/***/ 447:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unit_archived_vue__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__unit_archived_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__unit_archived_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_current_vue__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unit_current_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__unit_current_vue__);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unit'],

  computed: {
    showArchived: function showArchived() {
      return this.$store.state.showArchived;
    }
  },

  components: {
    UnitArchived: __WEBPACK_IMPORTED_MODULE_0__unit_archived_vue___default.a,
    UnitCurrent: __WEBPACK_IMPORTED_MODULE_1__unit_current_vue___default.a
  }
});

/***/ }),

/***/ 448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unit'],

  data: function data() {
    return {
      period: null
    };
  },


  watch: {
    period: function period() {
      this.goToPlans();
    }
  },

  computed: {
    level: function level() {
      if (this.unit.sub_program_level) {
        return this.unit.sub_program_level.code;
      } else if (this.unit.program_level) {
        return this.unit.program_level.code;
      } else {
        return '';
      }
    },
    label: function label() {
      return '' + this.name; // (${this.code})`
    },
    name: function name() {
      return (this.unit[this.unit.type] || {}).name;
    },
    active: function active() {
      return !this.unit.inactive;
    },
    periodId: function periodId() {
      return this.$store.getters.currentPeriod.id;
    },
    planString: function planString() {
      return this.plan_count > 1 ? 'Plans' : 'Plan';
    },
    planCount: function planCount() {
      return this.planPeriod.plan_count;
    },
    planPeriod: function planPeriod() {
      return this.unit.currentPlanPeriod;
    },
    classes: function classes() {
      return {
        'unit-item': true,
        'major-listing': true,
        'active': this.active
      };
    },
    unitParams: function unitParams() {
      return {
        period_id: this.periodId,
        layout_id: this.unit.university_layout_id
      };
    }
  },

  methods: {
    goToPlans: function goToPlans() {
      if (this.active) {
        this.$router.push({
          name: 'unit-plans',
          params: {
            period_id: this.period.id,
            layout_id: this.unit.university_layout_id
          }
        });
      }
    }
  }
});

/***/ }),

/***/ 449:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['unit'],

  computed: {
    level: function level() {
      if (this.unit.sub_program_level) {
        return this.unit.sub_program_level.code;
      } else if (this.unit.program_level) {
        return this.unit.program_level.code;
      } else {
        return '';
      }
    },
    onlineAvailability: function onlineAvailability() {
      if (this.unit.online_availability === undefined || this.unit.online_availability == 0) {
        return null;
      } else {
        return this.unit.online_availability;
      }
    },
    label: function label() {
      return '' + this.name; // (${this.code})`
    },
    name: function name() {
      return (this.unit[this.unit.type] || {}).name;
    },
    code: function code() {
      return (this.unit[this.unit.type] || {}).code;
    },
    showArchived: function showArchived() {
      return this.$store.state.showArchived;
    },
    active: function active() {
      return !this.unit.inactive;
    },
    periodId: function periodId() {
      return this.$store.getters.currentPeriod.id;
    },
    classes: function classes() {
      return {
        'unit-item': true,
        'major-listing': true,
        'active': this.active
      };
    },
    nameStyle: function nameStyle() {
      if (this.active && this.planPeriod) return { cursor: 'pointer' };
    },
    planString: function planString() {
      return this.plan_count > 1 ? 'Plans' : 'Plan';
    },
    planCount: function planCount() {
      return this.planPeriod.plan_count;
    },
    planPeriod: function planPeriod() {
      return this.unit.currentPlanPeriod;
    },
    unitParams: function unitParams() {
      return {
        period_id: this.periodId,
        layout_id: this.unit.university_layout_id
      };
    }
  },
  methods: {
    goToPlans: function goToPlans() {
      if (this.active && this.planPeriod) {
        this.$router.push({
          name: 'unit-plans',
          params: this.unitParams
        });
      }
    }
  }
});

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Footer'
});

/***/ }),

/***/ 451:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Header'
});

/***/ }),

/***/ 452:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wildcard',

  // Properties
  // Req - The requirement object
  props: ['req'],

  methods: {
    // used to roll credit count up to parent requirement sets
    computeMinimumCredits: function computeMinimumCredits() {
      return this.req.minimum_credits;
    }
  }
});

/***/ }),

/***/ 453:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_major_list__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'InterestSearch',

  data: function data() {
    var _this = this;

    return {
      notNextTick: true,
      autoPlayTimeout: null,
      allInterestAreas: [],
      swiperOptions: {
        slidesPerView: 5,
        mousewheelControl: true,
        // freeMode: true,
        spaceBetween: 20,
        direction: 'horizontal',
        centeredSlides: true,
        initialSlide: 0,
        threshold: 25,
        onSlideChangeStart: function onSlideChangeStart(swiper) {
          _this.goToArea(swiper.realIndex);
        }
      }
    };
  },
  created: function created() {
    var _this2 = this;

    this.setSlideCount();

    window.addEventListener('resize', function () {
      _this2.setSlideCount();
    });
  },
  mounted: function mounted() {
    var _this3 = this;

    this.$http('interest_areas_2.json').then(function (response) {
      _this3.allInterestAreas = response.data;
      if (!_this3.currentQuery) _this3.goToArea(0);
      _this3.swiperOptions.initialSlide = _this3.currentIndex;
      // console.log(this.$http('interest_areas_2.json'))
    }).catch(function (error) {
      return console.log(error);
    });

    window.addEventListener('keyup', this.slide);
    this.resetAutoPlayTimeout();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keyup', this.slide);
    clearTimeout(this.autoPlayTimeout);
  },


  watch: {
    currentArea: function currentArea() {
      this.centerCarousel();
    }
  },

  computed: {

    // only include interest areas that have majors
    interestAreas: function interestAreas() {
      var _this4 = this;

      return this.allInterestAreas.filter(function (area) {
        return !!_this4.majors.find(function (major) {
          if ('cip_code_id_additional' in area) {
            return major.master_cip_code_id === area.cip_code_id_additional;
          } else {
            return major.master_cip_code_id === area.cip_code_id;
          }
        });
      });
    },


    // get feedback url
    feedbackUrl: function feedbackUrl() {
      return this.$store.state.university.feedback_url;
    },


    // fetch majors from store
    majors: function majors() {
      return this.$store.getters.currentMajors;
    },


    // majors for current interest area
    currentMajors: function currentMajors() {
      var _this5 = this;

      if (!this.currentArea) return [];
      return this.majors.filter(function (major) {
        if ('cip_code_id_additional' in _this5.currentArea && major.master_cip_code_id === _this5.currentArea.cip_code_id_additional) {
          return major.master_cip_code_id === _this5.currentArea.cip_code_id_additional;
        } else {
          return major.master_cip_code_id === _this5.currentArea.cip_code_id;
        }
      });
    },


    // querystring current interest param
    currentQuery: function currentQuery() {
      return this.$route.query.interest;
    },


    // index of current interest area
    currentIndex: function currentIndex() {
      return this.interestAreas.indexOf(this.currentArea);
    },


    // current interest area
    currentArea: function currentArea() {
      var _this6 = this;

      return this.interestAreas.find(function (a) {
        return a.cip_code_id == _this6.currentQuery;
      });
    },


    // get selected from the query, on set $route to the interest area
    selected: {
      get: function get() {
        return ['true', true].includes(this.$route.query.selected);
      },
      set: function set(selected) {
        this.goToArea(this.currentIndex, selected);
      }
    }
  },

  methods: {
    // $route to interest area, optional selected query param may be set
    goToArea: function goToArea(index) {
      var selected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selected;
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'replace';

      this.swiperOptions.initialSlide = index;
      var query = { interest: this.interestAreas[index].cip_code_id };
      if (selected) query.selected = true;
      this.$router[method]({
        name: 'interestSearch',
        query: query
      });
      this.resetAutoPlayTimeout();
    },
    openFeedback: function openFeedback() {
      window.open(this.feedbackUrl);
    },
    resetAutoPlayTimeout: function resetAutoPlayTimeout() {
      var _this7 = this;

      clearTimeout(this.autoPlayTimeout);
      this.autoPlayTimeout = setTimeout(function () {
        if (!_this7.selected) _this7.nextArea();
      }, 10000);
    },
    swiperClick: function swiperClick(area, i) {
      if (area === this.currentArea) this.selected = !this.selected;else this.goToArea(i);
    },


    // $route to next interest area
    nextArea: function nextArea() {
      var count = this.interestAreas.length - 1;
      var index = this.currentIndex;
      var next = index < count ? index + 1 : 0;
      this.goToArea(next);
    },


    // $route to next interest area
    previousArea: function previousArea() {
      var count = this.interestAreas.length - 1;
      var index = this.currentIndex;
      var prev = index > 0 ? index - 1 : count;
      this.goToArea(prev);
    },


    // interest area slide events for left right arrow keys
    slide: function slide(e) {
      if (e.keyCode === 37) {
        this.previousArea();
      } else if (e.keyCode === 39) {
        this.nextArea();
      }
    },
    setSlideCount: function setSlideCount() {
      this.swiperOptions.slidesPerView = Math.max(1.6, Math.round(document.body.clientWidth / 330));
    },
    centerCarousel: function centerCarousel() {
      if (this && this.$refs.swiper) {
        this.$refs.swiper.swiper.slideTo(this.currentIndex);
      }
    }
  },

  components: {
    MajorList: __WEBPACK_IMPORTED_MODULE_0__components_major_list___default.a
  }
});

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_major_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_major_list__);
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'KeywordSearch',

  data: function data() {
    return {
      // searchKey: ''
      // majors: []
    };
  },


  computed: {
    searchKey: {
      get: function get() {
        return this.$route.query.keyword;
      },
      set: function set(keyword) {
        this.$router.replace({
          name: 'nameSearch',
          query: { keyword: keyword }
        });
      }
    },

    // Filters majors based on their name and the search key
    filteredMajors: function filteredMajors() {
      var searchRegex = new RegExp(this.searchKey, 'i');
      return this.majors.filter(function (major) {
        return searchRegex.test((major.program || {}).name) || searchRegex.test((major.program || {}).code) || searchRegex.test((major.concentration || {}).name) || searchRegex.test((major.concentration || {}).code);
      });
    },
    majors: function majors() {
      return this.$store.getters.currentMajors;
    }
  },

  components: {
    'major-list': __WEBPACK_IMPORTED_MODULE_0__components_major_list___default.a
  }
});

/***/ }),

/***/ 455:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Landing',

  data: function data() {
    return {
      searching: false,
      searchKey: ''
    };
  },


  methods: {
    search: function search() {
      this.$router.push({
        name: 'nameSearch',
        query: { keyword: this.searchKey }
      });
    }
  }
});

/***/ }),

/***/ 456:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 457:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Unit',

  data: function data() {
    return {
      isFromMajorList: false,
      periodId: 0
    };
  },


  computed: {
    name: function name() {
      return this.unit[this.unit.type].name;
    },
    level: function level() {
      if (this.unit.sub_program_level) {
        return this.unit.sub_program_level.code;
      } else if (this.unit.program_level) {
        return this.unit.program_level.code;
      } else {
        return '';
      }
    },
    programName: function programName() {
      return this.unit.program.name;
    },
    concentrationName: function concentrationName() {
      if (this.unit.concentration) {
        return ' / ' + this.unit.concentration.name;
      }
    },
    college: function college() {
      return this.unit.college.name;
    },


    unit: {
      get: function get() {
        return this.$store.state.unit;
      },
      set: function set(unit) {
        this.$store.commit('setUnit', unit);
      }
    },

    unitPeriod: function unitPeriod() {
      return this.$store.state.unitPeriod;
    },
    credits: function credits() {
      return this.setCorrectPeriodDegreeJoin(this.unitPeriod.period_degree_joins)[0].total_credit_hours;
    },
    unitPath: function unitPath() {
      return 'universities/' + "mesalands-community-college" + '/university_layouts/' + this.$route.params.layout_id + '.json';
    },
    currentPeriod: function currentPeriod() {
      var _this = this;

      return this.$store.state.periods.find(function (p) {
        return p.id === parseInt(_this.periodId);
      });
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      if (from.name === 'nameSearch' || from.name === 'interestSearch') {
        vm.isFromMajorList = true;
      }
    });
  },
  created: function created() {
    this.fetchData();
  },


  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData: function fetchData() {
      var _this2 = this;

      this.unit = null;
      this.periodId = this.$route.params.period_id;
      this.$http.get(this.unitPath).then(function (response) {
        _this2.unit = response.data;
      }).catch(function (error) {
        console.log(error);
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(error);
      });
    },
    goBack: function goBack() {
      if (this.isFromMajorList) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'nameSearch' });
      }
    },
    setCorrectPeriodDegreeJoin: function setCorrectPeriodDegreeJoin(periodDegreeJoins) {
      return periodDegreeJoins.filter(function (x) {
        return x.degree_type.code == 'MAJOR';
      });
    }
  }
});

/***/ }),

/***/ 458:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_program_information_vue__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_program_information_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_program_information_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitInfo',

  data: function data() {
    return {};
  },


  computed: {
    unit: function unit() {
      return this.$store.state.unit;
    },
    name: function name() {
      return this.unit[this.unit.type].name;
    },
    college: function college() {
      return this.unit.college.name;
    },
    hasInfo: function hasInfo() {
      return this.unit.cip_code || this.unit.description || this.unit.point_of_contact;
    }
  },

  components: {
    CareerOpportunities: __WEBPACK_IMPORTED_MODULE_0__components_career_opportunities_vue___default.a,
    ProgramInformation: __WEBPACK_IMPORTED_MODULE_1__components_program_information_vue___default.a,
    ContactInformation: __WEBPACK_IMPORTED_MODULE_2__components_contact_information_vue___default.a
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitPeriod',

  computed: {
    unitPeriod: {
      get: function get() {
        return this.$store.state.unitPeriod;
      },
      set: function set(unitPeriod) {
        this.$store.commit('setUnitPeriod', unitPeriod);
      }
    },

    unitPeriodPath: function unitPeriodPath() {
      return 'universities/' + "mesalands-community-college" + '/academic_periods/' + this.$route.params.period_id + '/university_layouts/' + this.$route.params.layout_id + '.json';
    }
  },

  created: function created() {
    this.fetchData();
  },


  watch: {
    '$route': 'fetchData'
  },

  methods: {
    fetchData: function fetchData() {
      var _this = this;

      this.unitPeriod = null;
      this.$http.get(this.unitPeriodPath).then(function (response) {
        _this.unitPeriod = response.data;
      });
    }
  }
});

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__idi_vue_degree_plan__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__idi_vue_degree_plan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__idi_vue_degree_plan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(233);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import http from '../http'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'UnitPlans',

  data: function data() {
    var planTypes = [['Plan', 'fa-list'], ['Grid', 'fa-th'], ['Graph', 'fa-share-alt']];
    return {
      // unit: null,
      activePlanIndex: 0,
      selectedPlanType: planTypes[0],
      planTypes: planTypes,
      formatTerms: __WEBPACK_IMPORTED_MODULE_1__idi_vue_degree_plan__["formatTerms"],
      expand: false,
      specialRequirementConfigs: {}
    };
  },


  watch: {
    specialRequirements: function specialRequirements(sr) {
      // this.specialRequirementConfigs = sr.map(sr => {
      //   return {
      //     id: sr.id,
      //     req: sr,
      //     selectedMinor: null,
      //     selectedSecondMajor: null,
      //     locked: false
      //     // minorOptions: (sr.minors_map || [])
      //     //   .map(minor => {
      //     //     return this.layouts.find(unit => {
      //     //       return unit.university_layout_id === minor.university_layout_id
      //     //     })
      //     //   })
      //     //   .filter(minor => minor),
      //     // secondMajorOptions: (sr.second_majors_map || [])
      //     //   .map(major => {
      //     //     return this.layouts.find(unit => {
      //     //       return unit.university_layout_id === major.university_layout_id
      //     //     })
      //     //   })
      //     //   .filter(major => major)
      //   }
      // })
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['termIdentifier', 'unitMajor', 'currentMajors']), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])(['unitPeriod', 'layouts']), {
    specialRequirements: function specialRequirements() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["keyBy"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["get"])(this.unitMajor, 'special_requirements', []).map(function (r) {
        return { requirement: r };
      }), function (r) {
        return r.requirement.id;
      });
    },


    // specialRequirementsConfig() {
    //   return this.specialRequirements.map(sr => {
    //     return {

    //     }
    //   })
    // },

    selectedTermItem: {
      get: function get() {
        return this.$store.state.selectedTermItem;
      },
      set: function set(item) {
        this.$store.commit('setSelectedTermItem', item);
      }
    },

    setCollapse: function setCollapse() {
      if (this.expand === true) {
        return false;
      } else {
        return true;
      }
    },
    name: function name() {
      return this.unitPeriod[this.unitPeriod.type].name;
    },
    college: function college() {
      return this.unitPeriod.college.name;
    },


    // major() {
    //   return this.unitPeriod.period_degree_joins.filter(pdj => pdj.degree_type.code === 'MAJOR')
    // },

    credits: function credits() {
      return this.unitMajor.total_credit_hours;
      // return this.unitPeriod.setperiod_degree_joins[0].total_credit_hours
    },
    plans: function plans() {
      return this.unitMajor.plan_period_joins.sort(function (a, b) {
        return a.plan.plan_type.code === 'DEFAULT' ? -1 : b.plan.plan_type.code === 'DEFAULT' ? 1 : 0;
      });
    },
    planNotes: function planNotes() {
      return this.unitMajor.plan_period_joins[this.activePlanIndex].plan.plan_notes;
    },
    activePlan: function activePlan() {
      return this.plans[this.activePlanIndex];
    }
  }),

  methods: {
    sortTerms: function sortTerms(terms) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["sortBy"])(terms, 'position');
    },
    setExpand: function setExpand() {
      this.expand = true;
    },
    setCollapseBack: function setCollapseBack() {
      this.expand = false;
    }
    // setCorrectPeriodDegreeJoin(periodDegreeJoins) {
    //   return periodDegreeJoins.filter(x => x.degree_type.code == 'MAJOR')
    // }

  },

  components: {
    Plan: __WEBPACK_IMPORTED_MODULE_1__idi_vue_degree_plan__["Plan"],
    Graph: __WEBPACK_IMPORTED_MODULE_1__idi_vue_degree_plan__["Graph"],
    Grid: __WEBPACK_IMPORTED_MODULE_1__idi_vue_degree_plan__["Grid"]
  }
});

/***/ }),

/***/ 461:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_unm_footer_vue__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_unm_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_unm_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_unm_header_vue__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_unm_header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_unm_header_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'University',

  components: {
    UnmFooter: __WEBPACK_IMPORTED_MODULE_1__components_unm_footer_vue___default.a,
    UnmHeader: __WEBPACK_IMPORTED_MODULE_2__components_unm_header_vue___default.a
  },

  data: function data() {
    return {
      // showNav: false,
      searchFocused: false,
      showSearchDropdown: false,
      showProgramLevelDropdown: false,
      // selectedProgramLevel: 'Bachelor\'s',
      searchKey: ''
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.setUniversity();
    this.setLayouts();
    this.setPeriods();
    document.body.addEventListener('click', function () {
      // this.showNav = false
      _this.showProgramLevelDropdown = false;
    });
  },


  watch: {
    showNav: function showNav(bool) {
      document.body[bool ? 'addEventListener' : 'removeEventListener']('click', this.toggleNav);
    },
    $route: function $route() {
      this.showSearchDropdown = this.showProgramLevelDropdown = false;
    }
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // console.log('University Enter')
    next();
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // console.log('University Update')
    next();
  },


  computed: {
    // Returns the url to the university's stylesheet
    stylesheet: function stylesheet() {
      return this.$store.state.university.styles_url;
    },


    // Returns a url to the university's logo
    logo: function logo() {
      return this.$store.state.university.logo_url;
    },


    // // Returns a url to the university's favicon
    // favicon() {
    //   return this.$store.state.university.favicon_url
    // },

    // Checks if currently on the landing route
    homeRoute: function homeRoute() {
      return this.$route.name == 'landing';
    },


    // University ID
    id: function id() {
      return this.$store.state.id;
    },
    showProgramLevelMenu: function showProgramLevelMenu() {
      return ['nameSearch', 'interestSearch'].includes(this.$route.name) && this.programLevels.length > 1;
    },
    programLevels: function programLevels() {
      return ['All'].concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash__["uniq"])(this.$store.getters.currentMajors.filter(function (m) {
        return m.program_level;
      }).map(function (m) {
        return m.program_level.name;
      })));
    },


    selectedProgramLevel: {
      get: function get() {
        return this.$store.state.selectedProgramLevel;
      },
      set: function set(pl) {
        this.$store.commit('setSelectedProgramLevel', pl);
      }
    }
  },

  methods: {
    search: function search() {
      this.$router.push({
        name: 'nameSearch',
        query: { keyword: this.searchKey }
      });
      this.searchKey = '';
    },


    // toggleNav() {
    //   this.showNav = !this.showNav
    // },

    // Saves the universities info to the store
    setUniversity: function setUniversity() {
      var _this2 = this;

      this.$http('universities/' + this.id + '.json').then(function (response) {
        _this2.$store.commit('setUniversity', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },


    // Pulls the university Layouts file
    setLayouts: function setLayouts() {
      var _this3 = this;

      this.$http('universities/' + this.id + '/university_layouts.json').then(function (response) {
        _this3.$store.commit('setLayouts', response.data);
      }).catch(function (error) {
        console.log(error);
      });
    },


    // Pulls the university period joins with degree roadmaps enabled
    setPeriods: function setPeriods() {
      var _this4 = this;

      this.$http('universities/' + this.id + '/university_period_joins.json').then(function (response) {
        // only write periods that are published for degree_roadmaps
        var filtered = response.data.filter(function (join) {
          return join.has_plan_content && join.degree_roadmaps_available;
        }).map(function (join) {
          return join.academic_period;
        });
        _this4.$store.commit('setPeriods', filtered);
      }).catch(function (error) {
        console.log(error);
      });
    }

    // closeNav() {
    //   this.showNav = false
    // }

  }
});

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 996:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[433]);


// WEBPACK FOOTER //
// static/js/app.79007d12df025bb7501b.js